import { DeviceRemovalReason } from 'store/types'

export const DEVICE_REMOVAL_REASON_LABELS: Record<DeviceRemovalReason, string> = {
  [DeviceRemovalReason.LOST_BY_PATIENT]: 'Lost by Patient',
  [DeviceRemovalReason.DAMAGED_BY_PATIENT]: 'Damaged by Patient',
  [DeviceRemovalReason.LOST_BY_USPS]: 'Lost by USPS',
  [DeviceRemovalReason.DAMAGED_BY_USPS]: 'Damaged by USPS',
  [DeviceRemovalReason.WRONG_ADDRESS]: 'Wrong Address',
  [DeviceRemovalReason.RETEST_NOT_ENOUGH_DATA]: 'Retest - Not Enough Data',
  [DeviceRemovalReason.DEVICE_ERROR]: 'Device Malfunction/Error',
  // the check-out does not count toward the device's usage (TES-3191)
  [DeviceRemovalReason.NOT_USED]: 'Device Not Used',
}

export const DEVICE_REMOVAL_REASON_OPTIONS = Object.entries(DEVICE_REMOVAL_REASON_LABELS).map(
  ([value, label]) => ({
    value: value as DeviceRemovalReason,
    label,
  })
);
